import React from 'react';
import { Typography } from '@raisin/components-lib';
import * as S from './styles';

export const Hero = ({ heading, body }: { heading: string; body: string }) => (
  <S.HeroWrapper data-testId="hero-wrapper">
    <S.FlexContainer data-testId="flex-container">
      <S.ContentWrapper data-testId="content-wrapper">
        <S.Heading variant="h2" color="white" data-testId="heading">
          {heading}
        </S.Heading>
        <Typography variant="body1" color="white">
          {body}
        </Typography>
      </S.ContentWrapper>
    </S.FlexContainer>
  </S.HeroWrapper>
);
